import React from 'react'

import OrJala from 'images/or-jala.inline.svg'
import { Header5, Header6} from 'components/UI/Header'

const RoadshowBlock = ({ title, date, onClick, clickable, active }) => {

    let containerClass = ''
    if ( clickable ) {
        if ( active ) {
            containerClass = 'bg-black text-white'
        } else {
            containerClass = 'bg-gray-300 text-primary hover:text-black'
        }
    } else {
        containerClass = 'bg-primary text-white cursor-default'
    }
    return (
        <div className={`p-4 flex justify-between ${containerClass}`} onClick={onClick} role="button">
            <div className="w-full">
                <h5 className=" text-2xl font-bold mb-6" dangerouslySetInnerHTML={ {__html: title }} />
                <Header6 className="text-sm">{ date }</Header6>
            </div>
            <div className="ml-4 ">
                <OrJala className="w-16 h-auto" />
            </div>
        </div>
    )
}

export default RoadshowBlock
